export class PrePopulateDetailsForQuestionnaire {
    hdWorkItemId: string;
    primarySolutionCode: string;
    secondarySolutionCode: string;
    descriptionPrimaryAssignmentCode:string;
    descriptionSecondaryAssignmentCode:string;
    periodEndDate:Date;
}